<template>
    <div>
        <div v-if="showError">
            <div class="alert alert-danger mb-4" role="alert">
                <ul>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </div>
        </div>
        <div v-if="showSuccess">
            <div class="alert alert-success mb-4" role="alert">
                Updated successfully.
            </div>
        </div>

        <div class="row">
            <div class="col-4 col-md-4">
                <select v-model="dob_d" class="form-control" required>
                    <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
                </select>
            </div>
            <div class="col-4 col-md-4">
                <select v-model="dob_m" class="form-control" required>
                    <option v-for="month in months" :key="month.value" :value="month.value">{{ month.text }}</option>
                </select>
            </div>
            <div class="col-4 col-md-4">
                <select v-model="dob_y" class="form-control" required>
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
            </div>

            <div class="col-12 mt-4">
                <button type="button" class="btn btn-primary" @click="save" :disabled="isBusy">{{ btnText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: false,
            default: null
        },
    },
    data() {
        return {
            dob_d: '',
            dob_m: '',
            dob_y: '',
            days: Array.from({ length: 31 }, (_, i) => i + 1),
            months: Array.from({ length: 12 }, (_, i) => ({
                value: i + 1,
                text: new Date(0, i).toLocaleString('default', { month: 'short' })
            })),
            years: [],
            isBusy: false,
            showError: false,
            showSuccess: false,
            errors: null,
            btnText: 'Update',
        }
    },

    mounted() {
        this.initializeYears();
        this.setInitialValues();
    },

    methods: {
        initializeYears() {
            const minAge = 12;
            const currentYear = new Date().getFullYear();
            const startYear = 1920;
            const endYear = currentYear - minAge;
            this.years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
        },

        setInitialValues() {
            if (this.user && this.user.dob) {
                const dob = new Date(this.user.dob);
                this.dob_d = dob.getDate();
                this.dob_m = dob.getMonth() + 1;
                this.dob_y = dob.getFullYear();
            } else {
                this.dob_d = '';
                this.dob_m = '';
                this.dob_y = 2000;
            }
        },

        // @TODO: Save the value user the /api/me/update-user endpoint, then fire dob-updated event
        save() {
            this.isBusy = true;
            this.errors = null;
            this.showError = false;
            this.btnText = 'Please wait...';
            this.showSuccess = false;

            axios.post('/api/me/update', {
                user: {
                    dob: `${this.dob_y}-${this.dob_m}-${this.dob_d}`,
                },
            })
                .then(response => {
                    this.isBusy = false;
                    this.showSuccess = true;
                    this.btnText = 'Save';
                    this.$emit('dob-updated', response.data);
                })
                .catch(error => {
                    this.isBusy = false;
                    this.showError = true;
                    this.btnText = 'Save';
                    this.errors = error.response.data.errors;
                });
        },
    }
}
</script>
